<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          v-if="subscribersGained"
          icon="ArrowUpIcon"
          :statistic="subscribersGained.values"
          statisticTitle="ปริมาณนำเข้าวันนี้"
          :chartData="subscribersGained.series"
          color="success"
          type="area"
        />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          v-if="revenueGenerated"
          icon="ArrowDownIcon"
          :statistic="revenueGenerated.values"
          statisticTitle="ปริมาณนำออกวันนี้"
          :chartData="revenueGenerated.series"
          color="danger"
          type="area"
        />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          v-if="quarterlySales"
          icon="RepeatIcon"
          :statistic="quarterlySales.values"
          statisticTitle="ปริมาณงานZ1-Z3"
          :chartData="quarterlySales.series"
          type="area"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          v-if="ordersRecevied"
          icon="ClockIcon"
          :statistic="ordersRecevied.values"
          statisticTitle="จำนวนสินค้าตกค้าง"
          :chartData="ordersRecevied.series"
          color="warning"
          type="area"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./card/analyticsData.js";

export default {
  components: {
    StatisticsCardLine
  },
  data() {
    return {
      myInterval:null,
      savingvalue: 0,
      withdrawvalue: 0,
      savingcount: 0,
      withdrawcount: 0,
      analyticsData: analyticsData,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },

      subscribersGained: {
        values: 0,
        series: [
          {
            name: "จำนวน",
            data: [28, 40, 36, 52, 38, 60, 55]
          }
        ],
        chartOptions: {
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth",
            width: 2.5
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.9,
              opacityFrom: 0.7,
              opacityTo: 0.5,
              stops: [0, 80, 100]
            }
          },
          xaxis: {
            type: "numeric",
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: { show: false }
          },
          yaxis: [
            {
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 }
            }
          ],
          tooltip: {
            x: { show: false }
          }
        }
      },
      revenueGenerated: {
        values: 0,
        series: [
          {
            name: "จำนวน",
            data: [350, 275, 400, 300, 350, 300, 450]
          }
        ],
        chartOptions: {
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth",
            width: 2.5
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.9,
              opacityFrom: 0.7,
              opacityTo: 0.5,
              stops: [0, 80, 100]
            }
          },
          xaxis: {
            type: "numeric",
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: { show: false }
          },
          yaxis: [
            {
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 }
            }
          ],
          tooltip: {
            x: { show: false }
          }
        }
      },
      quarterlySales: {
        values: 0,
        series: [
          {
            name: "จำนวน",
            data: [10, 15, 7, 12, 3, 16]
          }
        ],
        chartOptions: {
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth",
            width: 2.5
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.9,
              opacityFrom: 0.7,
              opacityTo: 0.5,
              stops: [0, 80, 100]
            }
          },
          xaxis: {
            type: "numeric",
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: { show: false }
          },
          yaxis: [
            {
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 }
            }
          ],
          tooltip: {
            x: { show: false }
          }
        }
      },
      ordersRecevied: {
        values: 0,
        series: [
          {
            name: "จำนวน",
            data: [10, 15, 8, 15, 7, 12, 8]
          }
        ],
        chartOptions: {
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth",
            width: 2.5
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.9,
              opacityFrom: 0.7,
              opacityTo: 0.5,
              stops: [0, 80, 100]
            }
          },
          xaxis: {
            type: "numeric",
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: { show: false }
          },
          yaxis: [
            {
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 }
            }
          ],
          tooltip: {
            x: { show: false }
          }
        }
      }
    };
  },
  methods: {
    randnum() {
      let rnum = Math.floor(Math.random() * (99 - 10));

      return rnum;
    },
    randnum2() {
      let rnum = Math.floor(Math.random() * (1000 - 100));
      this.savingvalue = +this.savingvalue + rnum;
      let pnum = +this.savingvalue;

      return pnum.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + " บาท";
    },
    randnum3() {
      let rnum = Math.floor(Math.random() * (600 - 100));
      this.withdrawvalue = +this.withdrawvalue + rnum;
      let pnum = +this.withdrawvalue;

      return pnum.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + " งาน";
    },
    randnum4() {
      let rnum = Math.floor(Math.random() * (3 - 1));
      this.savingcount = +this.savingcount + rnum;
      let pnum = +this.savingcount;

      return pnum + " งาน";
    },
    randnum5() {
      let rnum = Math.floor(Math.random() * (3 - 1));
      this.withdrawcount = +this.withdrawcount + rnum;
      let pnum = +this.withdrawcount;

      return pnum + " งาน";
    },
    myTimer() {
      this.subscribersGained.series[0].data = [
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum()
      ];

      this.revenueGenerated.series[0].data = [
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum()
      ];

      this.quarterlySales.series[0].data = [
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum()
      ];

      this.ordersRecevied.series[0].data = [
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum(),
        this.randnum()
      ];

      this.subscribersGained.values = this.randnum2();
      this.revenueGenerated.values = this.randnum3();
      this.quarterlySales.values = this.randnum4();
      this.ordersRecevied.values = this.randnum5();
    }
  },
  mounted() {
    //   setTimeout(() => {
    // //   console.log(this.subscribersGained.series[0].data);
    //       this.subscribersGained.series[0].data = [this.randnum(), 40, 36, 52, 38, 60, 55]
    //   }, 1000);

    // setTimeout(() => {
    //     this.subscribersGained.values=100;
    // }, 700);

    // setTimeout(() => {
    //      this.subscribersGained.series[0].data = [18, 30, 46, 52, 68, 70, 85]
    // }, 200);

    this.myInterval = setInterval(() => {
      this.myTimer();
      // console.log("interval");
    }, 3000);
    // console.log("Mounth") // 2
  },
  created() {
    //   console.log("created") // 1
  },
  destroyed(){
    clearInterval(this.myInterval);
  }
};
</script>

<style lang="scss"></style>
